import React, { createContext, useContext } from "react";
import { BankOfCoresService } from "../services/BankOfCoresService";
import { LoginService } from "../services/LoginService";
import { ApiKeysService } from "../services/ApiKeysService";

export interface ServicesContextDto {
    loginService: LoginService;
    bankOfCoresService: BankOfCoresService;
    apiKeysService: ApiKeysService;
}

const servicesContext = createContext<ServicesContextDto>({
    loginService: new LoginService(),
    bankOfCoresService: new BankOfCoresService(),
    apiKeysService: new ApiKeysService(),
});

export function ServiceProvider(props: { services: ServicesContextDto; children: JSX.Element }) {
    return <servicesContext.Provider value={props.services}>{props.children}</servicesContext.Provider>;
}

export const useServices = () => {
    return useContext(servicesContext);
};
